import { isNil } from "lopermut"
import { z } from "zod"
import { Errors } from "../errors"
import { KNOWLEDGE_BASE_FORMAT } from "../shared/files"
import { KnowledgeBaseItemKind } from "./response_data"

export const KNOWLEDGE_BASE_MAX_FILE_SIZE_MB = 20
export const KNOWLEDGE_BASE_MAX_FILE_SIZE_BYTES = KNOWLEDGE_BASE_MAX_FILE_SIZE_MB * 1024 * 1024

export const GetKnowledgeBase = z.object({
  kind: z.enum(KnowledgeBaseItemKind).optional(),
  campaignId: z.string().nullish(),
})

export const GetKnowledgeBaseItemParams = z.object({
  id: z.string().transform(BigInt),
})

export const CreateKnowledgeBaseItem = z.object({
  kind: z.enum(KnowledgeBaseItemKind),
  content: z.any().optional(),
  title: z.string().optional(),
  order: z.union([z.number(), z.string()]).transform(Number).optional(),
  campaignId: z.string().nullish(),
})

export const UpdateKnowledgeBaseItem = z.object({
  kind: z.enum(KnowledgeBaseItemKind).optional(),
  content: z.any().optional(),
  title: z.string().optional(),
  order: z.union([z.number(), z.string()]).transform(Number).optional(),
  campaignId: z
    .string()
    .nullish()
    .transform((value) => (!isNil(value) ? BigInt(value) : value)),
})

export const UpdateKnowledgeBaseItemParams = z.object({
  id: z.string().transform(BigInt),
})

export const CreateKnowledgeBaseItemFiles = z.object({
  content: z
    .object({
      data: z.unknown().refine((value) => Buffer.isBuffer(value), {
        error: "Expected a Buffer",
      }),
      name: z.string(),
      mimetype: z
        .string()
        .refine(
          (value) =>
            Object.values(KNOWLEDGE_BASE_FORMAT).includes(
              value as keyof typeof KNOWLEDGE_BASE_FORMAT,
            ),
          {
            message: Errors.KNOWLEDGE_BASE_UNSUPPORTED_FILE_FORMAT,
          },
        ),
    })
    .optional()
    .nullable(),
})

export const SortKnowledgeBaseItems = z.object({
  values: z.array(
    z.object({
      id: z.string().transform(BigInt),
      order: z.number(),
    }),
  ),
})

export const PlaygroundKnoledgeBaseBodySchema = z.object({
  query: z.string(),
})
